import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import MarathonsContent from '../../../components/Pages/Marathons/Menu';
import MarathonMenuProvider from '../../../context/marathonMenu';

const { displayName } = config;

export default function MarathonMenu(): React.ReactNode | null {
  document.title = `${displayName}: Редактировать меню`;

  return (
    <Layout>
      <MarathonMenuProvider>
        <MarathonsContent />
      </MarathonMenuProvider>
    </Layout>
  );
}
